import { useMutation } from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  GetInstallmentStatusRequestSchema,
  GetInstallmentStatusRequestType,
  GetInstallmentStatusResponseSchema,
  GetInstallmentStatusResponseType
} from '../../../services/IbInstallmentsServices/APIService/types';

import { useIbInstallmentsService } from '../useIbInstallmentsService';

interface UseGetInstallmentStatusApiInterface {
  getInstallmentStatusApi: (
    input: GetInstallmentStatusRequestType
  ) => Promise<GetInstallmentStatusResponseType>;
  isLoading: boolean;
  isError: boolean;
  error: string | null;
  status: 'idle' | 'loading' | 'success' | 'error';
  reset: () => void;
}

const useGetInstallmentStatusApi = (): UseGetInstallmentStatusApiInterface => {
  const { ibInstallmentsServiceInstance } = useIbInstallmentsService();

  const getInstallmentStatus = (
    requestObject: GetInstallmentStatusRequestType
  ) => {
    try {
      // Always validate request object against schema
      GetInstallmentStatusRequestSchema.parse(requestObject);
    } catch (error) {
      console.error('Invalid request object:', error);
      throw error;
    }

    return ibInstallmentsServiceInstance
      .getInstallmentStatus(requestObject)
      .then((response) => {
        try {
          // Always validate response against schema
          GetInstallmentStatusResponseSchema.parse(response);
        } catch (error) {
          console.error('Invalid response object:', error);
          throw error;
        }
        return response;
      });
  };

  const { mutateAsync, isLoading, isError, error, status, reset } = useMutation(
    getInstallmentStatus,
    {
      mutationKey: ['getInstallmentStatusApi']
    }
  );

  return {
    getInstallmentStatusApi: mutateAsync,
    isLoading,
    isError,
    error: error ? getAPIErrorMessage(error) : null,
    status,
    reset
  };
};

export { useGetInstallmentStatusApi };
